import { render, staticRenderFns } from "./DashboardRegistrations.vue?vue&type=template&id=25192ce8&scoped=true"
import script from "./DashboardRegistrations.vue?vue&type=script&lang=js"
export * from "./DashboardRegistrations.vue?vue&type=script&lang=js"
import style0 from "./DashboardRegistrations.vue?vue&type=style&index=0&id=25192ce8&prod&scoped=true&lang=css"
import style1 from "./DashboardRegistrations.vue?vue&type=style&index=1&id=25192ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25192ce8",
  null
  
)

export default component.exports